module.exports = __webpack_public_path__ + "static/media/settings.5b92ff5d.svg";